import { Box } from '@mui/material';
import BaseTypography from 'components/typography/BaseTypography';
import { reusableStyles } from 'ui-blocks/ReusableStyles';
import React from 'react';
import { unlockNewConfig } from 'config/unlockNewConfig';
import BaseImage from 'components/image/BaseImage';
import { useMediaQuery } from '@mui/system';
import { unlockNewStyles } from './unlockNewStyles';

export default function UnlockNewSection() {
	// const isBigScreen = useMediaQuery(appTheme.breakpoints.between('lg', 'xl'));
	// const isSmallScreen = useMediaQuery(appTheme.breakpoints.down('lg'));
	// TO DO
	const isBigScreen = useMediaQuery('(min-width:1281px) and (max-width:1440px)');
	const isSmallScreen = useMediaQuery('(max-width: 1280px)');

	return (
		<Box
			id="unlock-new-section"
			sx={[reusableStyles.flexColWithGap(36), reusableStyles.flexCenter]}
		>
			<BaseTypography variant="h2_zodiak" styles={{ color: 'colors.light3', textAlign: 'center' }}>
				Unlock New Possibilities with AI Characters
			</BaseTypography>

			<Box id="unlock-new-images-container" sx={[unlockNewStyles.imagesContainer]}>
				{unlockNewConfig.map((unlockNew) => (
					<Box key={`${unlockNew.id}-${unlockNew.title}`} sx={[unlockNewStyles.imageContainer]}>
						<BaseImage
							src={unlockNew.image}
							alt={unlockNew.title}
							style={unlockNewStyles.imageBaseStyle}
						/>

						<Box id="image-content" sx={[unlockNewStyles.imageContent]}>
							<BaseTypography
								variant="h3_zodiak"
								styles={{
									color: 'colors.light1',
								}}
							>
								{unlockNew.title}
							</BaseTypography>
							<BaseTypography
								variant={isBigScreen ? 'b1_regular' : isSmallScreen ? 'b2_regular' : 't2_regular'}
								styles={{
									color: 'colors.light1',
								}}
							>
								{unlockNew.description}
							</BaseTypography>
						</Box>
					</Box>
				))}
			</Box>
		</Box>
	);
}
